import { render, staticRenderFns } from "./PopupRedirectApprover.vue?vue&type=template&id=8ce32410&"
import script from "./PopupRedirectApprover.vue?vue&type=script&lang=js&"
export * from "./PopupRedirectApprover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports